

import { createSvgIcon } from "@mui/material/utils";

export const PhotoOutlinedIcon = createSvgIcon(
    <svg width="28" height="29" viewBox="0 0 28 29" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.52303 26.8328V23.477C4.52303 19.3996 7.82838 16.0943 11.9057 16.0943H18.6173C22.6947 16.0943 26 19.3996 26 23.477V26.8328M9.89228 26.8328V22.8059M20.6307 26.8328V22.8059M5.03261 8.04041L7.71724 10.725M5.03261 8.04041L2 10.725M5.03261 8.04041V14.0808M20.6307 7.36925C20.6307 10.3346 18.2269 12.7385 15.2615 12.7385C12.2962 12.7385 9.89228 10.3346 9.89228 7.36925C9.89228 4.4039 12.2962 2 15.2615 2C18.2269 2 20.6307 4.4039 20.6307 7.36925Z" stroke="#4540DB" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);